import { actions } from '@/modules/SuiviReclamation/store/actions';
import { getters } from '@/modules/SuiviReclamation/store/getters';
import { mutations } from '@/modules/SuiviReclamation/store/mutations';
import { state } from '@/modules/SuiviReclamation/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { SuiviReclamationState } from './state';

const module: Module<SuiviReclamationState, RootState> = {
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { SuiviReclamationState };
